import React from 'react';

import { Box, Typography } from '@mui/material';
import { ErrorFilledIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { AiChatTestIds } from '../../../../AiChat.testIds';
import { TOOL_CONFIRMATION_LABELS } from '../../ToolConfirmationCard.constants';
import {
  errorIconStyles,
  errorTextStyles,
  iconContainerStyles,
  statusContainerStyles,
} from '../../ToolConfirmationCard.styles';

const FailedStatus = ({ error }) => (
  <Box sx={statusContainerStyles}>
    <Box sx={iconContainerStyles}>
      <ErrorFilledIcon size={18} style={errorIconStyles} />
    </Box>
    <Typography
      data-testid={AiChatTestIds.TOOL_CONFIRMATION_CARD_ERROR}
      sx={errorTextStyles}
      variant="regular12"
    >
      {error ?? TOOL_CONFIRMATION_LABELS.FAILED}
    </Typography>
  </Box>
);

FailedStatus.propTypes = {
  error: PropTypes.string,
};

export default FailedStatus;
